import { createFileRoute, useNavigate, Link } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { PortfolioForm } from '@/components/forms/PortfolioForm';
import { useCreatePortfolio } from '@/lib/queries/portfolio';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';
import { toast } from 'sonner';

export const Route = createFileRoute('/portfolio/new')({ component: NewPortfolio });

function NewPortfolio() {
  const nav = useNavigate();
  const create = useCreatePortfolio();
  return (
    <>
      <div className="mb-3">
        <Button variant="ghost" size="sm" asChild className="-ml-2 text-muted-foreground">
          <Link to="/content" search={{ tab: 'portfolio', status: 'all', q: '', days: 30 }}>
            <ChevronLeft /> 포트폴리오
          </Link>
        </Button>
      </div>
      <PageHeader title="새 포트폴리오" description="새 프로젝트 항목을 추가합니다" />
      <PortfolioForm submitLabel="생성" onSubmit={async v => {
        try { const res = await create.mutateAsync(v); toast.success('생성됨'); nav({ to: '/portfolio/$id', params: { id: res.id } }); }
        catch (e) { toast.error((e as Error).message); }
      }} />
    </>
  );
}
